import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { MySkeleton } from "./MySkeleton";

export const ViewEnquiryTableSkeleton = ({ rows = 5, columns = 4 }) => {
  return (
    <div
      // className="scrollBar relative overflow-x-auto shadow-md sm:rounded-lg"
      className="scrollBar relative sm:rounded-lg h-auto max-h-[800px] mb-6"
    >
      <div className="flex gap-2 flex-wrap px-2 py-1 rounded-tr-md">
        <span className="px-0.5 rounded-full font-extrabold text-[16px]">
          <MySkeleton width="14px" height="15px" />
        </span>
        <span className="px-0.5 rounded font-extrabold text-[16px]">
          <MySkeleton width="50px" height="15px" />
        </span>
        <span className="px-0.5 rounded">
          <MySkeleton width="50px" height="15px" />
        </span>
        <span className="px-0.5 rounded">
          <MySkeleton width="50px" height="15px" />
        </span>
        <span className="font-bold px-0.5 rounded">
          <MySkeleton width="50px" height="15px" />
        </span>
      </div>

      <table
        className={`w-full text-[11px] uppercase text-left rtl:text-right text-gray-400 bg-slate-100`}
      >
        <thead>
          <tr className="!bg-white">
            {Array.from({ length: columns }).map((_, index) => (
              <th key={index} className="px-3 py-[10px]">
                {/* <Skeleton
                height={28}
                width={`100%`}
                baseColor="#eee"
                highlightColor="#ccc"
                duration={1.2}
              /> */}
                <MySkeleton width="70px" height="20px" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} className="!bg-white">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex} className="px-3 py-[10px]">
                  {/* <Skeleton
                  height={28}
                  width={`100%`}
                  baseColor="#eee"
                  highlightColor="#ccc"
                  duration={1.2}
                /> */}
                  <MySkeleton width="70px" height="20px" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
